import { get, post, put, del } from "./http";
import { BaseUrlNew } from "./NewSiteUrl";
import { headerDemo } from "./editHeader";

// ++++++++++ 文章审核发布 ++++++++++

// 查询文章/视频列表
export const getArticleVideoList = params =>get( BaseUrlNew + "/api/activityVideo/articleVideoList",params, 1, '3.0');
// 添加文章/视频
export const postAddArticleVideo = params =>post( BaseUrlNew + "/api/activityVideo/addArticleVideo",params, headerDemo, 1, '3.0');
// 修改文章/视频详情
export const getArticleVideoUpdateDetails = params =>get( BaseUrlNew + "/api/activityVideo/articleVideoUpdateDetails",params, 1, '3.0');
// 修改文章/视频
export const putUpdateArticleVideo = params =>put( BaseUrlNew + "/api/activityVideo/updateArticleVideo",params, headerDemo, 1, '3.0');
// 查看文章/视频详情
export const getArticleVideoSeeDetails = params =>get( BaseUrlNew + "/api/activityVideo/articleVideoSeeDetails",params, 1, '3.0');
// 删除文章/视频
export const deleteArticleVideo = params =>del( BaseUrlNew + "/api/activityVideo/deleteArticleVideo",params, 1, '3.0');
// 获取金专儿用户 & 获取发布用户
export const getArticleVideoJzUser = params =>get( BaseUrlNew + "/api/activityVideo/articleVideoJzUser",params, 1, '3.0');

// 封禁\解封文章
export const postBan = params =>post( BaseUrlNew + "/api/activityVideo/ban",params, headerDemo, 1, '3.0');
// 文章关联品牌店/特价商品列表
export const getBrandBusinessAndGoods = params =>get( BaseUrlNew + "/api/activityVideo/brandBusinessAndGoods",params, 1, '3.0');
// 获取文章视频标签
export const getLabel = params =>get( BaseUrlNew + "/api/activityVideo/label",params, 1, '3.0');
// 审核文章视频
export const postApproval = params =>post( BaseUrlNew + "/api/activityVideo/approval",params, headerDemo, 1, '3.0');

// ++++++++++ 装修记 ++++++++++

// 获取装修公司下拉框
export const dcSelectLable = params => get(BaseUrlNew + '/api/decoration/dcSelectLable', params, 1, '4.0');
// 获取装修公司整装商品下拉框
export const packageGoodsSelectLable = params => get(BaseUrlNew + '/api/decoration/packageGoodsSelectLable', params, 1, '5.0');
// 装修记列表
export const getDecorationList = params => get(BaseUrlNew + '/api/decoration/decoration', params, 1, '4.0');
// 新增装修记
export const postDecorationAdd = params =>post( BaseUrlNew + "/api/decoration/add",params, headerDemo, 1, '4.0');
// 装修记详情
export const getDecorationDetails = params => get(BaseUrlNew + '/api/decoration/details', params, 1, '4.0');
// 编辑装修记
export const putDecorationEdit = params =>put( BaseUrlNew + "/api/decoration/edit",params, headerDemo, 1, '4.0');
// 装修记评论列表
export const getDecorationCommentsList = params =>get( BaseUrlNew + "/api/decoration/decorationComments",params, 1, '4.0');
// 删除装修记
export const deleteDecoration = params =>del( BaseUrlNew + "/api/decoration/delete",params, 1, '4.0');
// 删除装修记评论
export const deleteComments = params =>del( BaseUrlNew + "/api/decoration/deleteComments",params, 1, '4.0');


// ++++++++++ 直播管理 ++++++++++

// 直播间

// 分页获取直播房间列表
export const roomgetlist = params =>post( BaseUrlNew + "/api/live/room/getlist",params, headerDemo, 1, '1.0');
// 新增直播房间
export const roomadd = params =>post( BaseUrlNew + "/api/live/room/add",params, headerDemo, 1, '1.0');
// 获取直播房间详情
export const roominfo = (params,shopId,roomId) =>get( BaseUrlNew + "/api/live/room/info/"+shopId+'/'+roomId,params, 1);
// 编辑直播房间
export const roomedit = params =>post( BaseUrlNew + "/api/live/room/edit",params, headerDemo, 1, '1.0');
// 删除直播房间
export const roomdel = params =>post( BaseUrlNew + "/api/live/room/del",params, headerDemo, 1, '1.0');
// 分享直播间
export const roomshare = (params,shopId,roomId) =>get( BaseUrlNew + "/api/live/room/share/"+shopId+'/'+roomId,params, 1);

// 直播商品库

// 分页获取直播商品库列表
export const goodsgetlist = params =>post( BaseUrlNew + "/api/live/goods/getlist",params, headerDemo, 1, '1.0');
// 获取店铺上架商品列表
export const getshopgoods = (params,shopId) =>get( BaseUrlNew + "/api/live/getshopgoods/"+shopId,params, 1);
// 新增直播商品
export const goodsadd = params =>post( BaseUrlNew + "/api/live/goods/add",params, headerDemo, 1, '1.0');
// 获取直播商品详情
export const goodsinfo = (params,shopId,roomId) =>get( BaseUrlNew + "/api/live/goods/info/"+shopId+'/'+roomId,params, 1);
// 更新直播商品
export const goodsedit = params =>post( BaseUrlNew + "/api/live/goods/edit",params, headerDemo, 1, '1.0');
// 删除直播商品
export const goodsdel = params =>post( BaseUrlNew + "/api/live/goods/del",params, headerDemo, 1, '1.0');
// 直播商品提交审核
export const goodsaudit = params =>post( BaseUrlNew + "/api/live/goods/audit",params, headerDemo, 1, '1.0');
// 直播商品撤销审核
export const goodscancel = params =>post( BaseUrlNew + "/api/live/goods/audit/cancel",params, headerDemo, 1, '1.0');
// 验证主播是否实名认证
export const memberadd = params =>post( BaseUrlNew + "/api/live/member/add",params, headerDemo, 1, '1.0');




// WEBPACK FOOTER //
// ./src/api/decoration.js